import React from 'react';

import Modal from '../Modal';
import modalStyles from '../Modal.scss';

class NewWordModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            word: '',
            disabled: true,
        };
    }
    componentDidUpdate() {
        if (this._input) this._input.focus();
    }
    handleChange = (evt) => {
        this.setState({
            word: evt.target.value,
            disabled: evt.target.value.length < 3,
        });
    };
    render() {
        const {
            open, onAddWord, onClose, button = '+ toevoegen',
        } = this.props;
        const { word, disabled } = this.state;

        if (!open) {
            return null;
        }

        return (
            <Modal onClose={onClose}>
                <div className={modalStyles.body}>
                    <form>
                        <div className="form-group">
                            <input
                                className="form-control"
                                type="text"
                                name="new-word"
                                value={word}
                                onChange={this.handleChange}
                                maxLength={30}
                                ref={c => this._input = c} // eslint-disable-line
                                autoFocus // eslint-disable-line
                            />
                            <small className="form-text text-muted float-right">
                                {this.state.word.length}
                                /30
                            </small>
                        </div>
                        <button
                            className="btn btn-primary"
                            disabled={disabled}
                            onClick={(e) => {
                                e.preventDefault();
                                onAddWord(this.state.word);
                                this.setState({ word: '' });
                            }}
                        >
                            {button}
                        </button>
                    </form>
                </div>
            </Modal>
        );
    }
}

export default NewWordModal;



// WEBPACK FOOTER //
// ./src/components/questions/NewWordModal.js